import React from 'react'
import { Flex, Heading, Border, Button, Fixed } from 'rebass'
import styled from 'styled-components'
import { connect } from 'react-redux'
import {
  FlatButton,
  AppBar,
  Popover,
  Menu,
  MenuItem,
  IconButton,
} from 'material-ui'
import { withState } from 'recompose'
import { NavigationMoreVert, NavigationMenu } from 'material-ui/svg-icons'

import { logOut, showMenu } from '../model/actions'
import { NavigationArrowBack } from 'material-ui/svg-icons'
import { NavigationClose } from 'material-ui/svg-icons'

class Header extends React.Component {
  constructor() {
    super()
    this.state = {
      isMenuOpen: false,
      menuAnchorEl: null,
    }
  }
  openMenu = e => {
    this.setState({ isMenuOpen: true, menuAnchorEl: e.currentTarget })
  }
  closeMenu = () => {
    this.setState({ isMenuOpen: false, menuAnchorEl: null })
  }
  render() {
    const {
      isMenuOpen,
      setMenuOpen,
      title,
      subtitle,
      action,
      onClick,
      loggedIn,
      logOut,
      showMenu,
      onBack = null,
      dropdown,
      onCancel,
    } = this.props

    let rightButton = action
    if (typeof action === 'string') {
      rightButton = (
        <FlatButton
          label={action}
          onClick={() => {
            onClick()
            this.dropdown && this.openMenu()
          }}
        />
      )
    }

    if (dropdown) {
      rightButton = (
        <FlatButton icon={<NavigationMoreVert />} onClick={this.openMenu} />
      )
    }

    let leftIcon = (
      <IconButton onClick={this.props.showMenu}>
        <NavigationMenu />
      </IconButton>
    )
    if (typeof onBack === 'function') {
      leftIcon = (
        <IconButton onClick={onBack}>
          <NavigationArrowBack />
        </IconButton>
      )
    } else if (typeof onCancel === 'function') {
      leftIcon = (
        <IconButton onClick={onCancel}>
          <NavigationClose />
        </IconButton>
      )
    }

    return [
      <AppBar
        title={title}
        iconElementLeft={leftIcon}
        iconElementRight={rightButton}
        key="appBar"
      />,
      <Popover
        open={this.state.isMenuOpen}
        anchorEl={this.state.menuAnchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        onRequestClose={this.closeMenu}
        key="menuPopover"
      >
        {dropdown}
      </Popover>,
    ]
  }
}

const mapState = state => {
  return {
    loggedIn: !!state.data.get('user'),
  }
}

const eventMap = {
  logOut,
  showMenu,
}

export default connect(mapState, eventMap)(Header)



// WEBPACK FOOTER //
// ./src/elements/Header.js